<template>
    <div id="emailable-status" class="flex">
        <slot name="email"></slot>
        <vx-tooltip :text="emailStatusName(source).status">
            <div v-if="profile_id != null" @click.stop="doValidateEmail()" class="email-status clickable-img" :class="emailStatusName(source).color"></div>
            <div v-else class="email-status" :class="emailStatusName(source).color"></div>
        </vx-tooltip>
    </div>
</template>

<script>
export default {
    name: "EmailableStatusComponent",
    props: {
        source: String,
        type: {
            type: [String],
            default: null,
        },
        profile_id: {
            type: [String, Number],
            default: null,
        },
        email: {
            type: [String],
            default: null,
        }
    },
    methods: {
        emailStatusName(emailData){

            let txt = this.profile_id != null ? "Click para actualizar" : "";

            if (emailData == null) {
                return {
                    status: 'Correo no verificado. ' + txt,
                    color: 'bg-grey-light',
                    raw_status: 'unknown',
                }
            }

            const jsonEmailData = JSON.parse(emailData);
            const status = jsonEmailData.state;
            const data = {
                status: "",
                color: "",
                raw_status: "",
            }
            switch (status) {
                case "deliverable":
                    data.status = 'Correo verificado: El correo parece válido y puede recibir correos.';
                    data.color = 'bg-success';
                    data.raw_status = status;
                    break;
                case "undeliverable":
                    data.status = 'Correo no alcanzable: Es casi seguro que no se puede entregar (dominio inválido, no hay registros MX, etc.).';
                    data.color = 'bg-danger';
                    data.raw_status = status;
                    break;
                case "risky":
                    data.status = `Riesgo: Puede ser válido, pero tiene señales de alerta: catch-all, temporal, basado en roles, etc.`;
                    data.color = 'bg-warning';
                    data.raw_status = status;
                    break;
                case "unknown":
                    data.status = 'Correo desconocido: No se pudo verificar por alguna razón (el servidor no respondió, bloqueó la consulta, etc.).';
                    data.color = 'bg-danger';
                    data.raw_status = status;
                    break;
                default:
                    data.status = 'No definido.';
                    data.color = 'bg-warning';
                    data.raw_status = status;
                    break;
            }

            data.status += ' ' + txt;

            return data;
        },
        async doValidateEmail(){
            try {
                this.showLoading(true, "Validando correo...");
                const res = await axios.post(`/api/v1/emailable/verify`, {
                    email: this.email,
                    type: this.type,
                    profile_id: this.profile_id
                });

                this.saveSuccessNotif(null, "Correo enviado a verificación, consulta más tarde su estado.");
            } catch (error) {
                console.error("Error emitting validate-email event:", error);
            } finally {
                this.showLoading(false);
            }
        }
    }
}
</script>